import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import './adminlogin.css';

const AdminLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const auth = getAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/admin/applications');
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className='login_container'>
            <h1>Admin Login</h1>
            <form onSubmit={handleSubmit}>
                <label htmlFor="email" className='label_tag'>Email:</label>
                <input
                    type="email"
                    placeholder="Enter your email"
                    className='input_tag'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <label htmlFor="password" className='label_tag'>Password:</label>
                <input
                    type="password"
                    placeholder="Enter your password"
                    className='input_tag'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button className='form_btn' type="submit">Login</button>
                {error && <p className='error_message'>{error}</p>}
            </form>
        </div>
    );
}

export default AdminLogin;
